/**
 * Author: Paul Grejaldo
 * Date: 2018/10/17
 * Time: 11:16 AM
 */
import { combineReducers } from 'redux';
import ServiceAreaReducer from './service-area';

export default combineReducers(
	{
		serviceAreaApp : ServiceAreaReducer
	}
);
